/*
 * sr-blog.js — Stone Rose blog (main-blog section)
 * Client-side category filter + article search + empty state.
 * Vanilla JS, no leaked globals, safe to defer-load.
 * DOM contract: _SR_BLOG_CONTRACT.md §5/§7. Operates within each [data-sr-blog].
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 120;
  var BOUND_FLAG = 'srBlogBound'; // dataset marker to keep binding idempotent

  // Per-container controller. State mirrors the design's renderVals():
  // filter 'All' shows all; otherwise compare against the card's categories.
  // query is matched as a case-insensitive substring over title+excerpt+tags.
  function initBlog(root) {
    if (!root || root.dataset[BOUND_FLAG] === 'true') return;
    root.dataset[BOUND_FLAG] = 'true';

    var grid = root.querySelector('[data-sr-grid]');
    if (!grid) return; // nothing to filter

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-sr-filter]'));
    var search = root.querySelector('[data-sr-search]');
    var empty = root.querySelector('[data-sr-empty]');
    var pagination = root.querySelector('[data-sr-pagination]');

    var state = { filter: 'All', query: '' };

    // Cache the cards once; the grid is server-rendered and static after load.
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-sr-card]'));

    if (empty && !empty.hasAttribute('aria-live')) {
      empty.setAttribute('aria-live', 'polite');
    }

    function apply() {
      var filter = state.filter.toLowerCase();
      var query = state.query;
      var anyFilterActive = state.filter !== 'All';
      var anyQuery = query !== '';
      var visibleCount = 0;

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var categories = (card.dataset.category || '').split('|');
        var haystack = card.dataset.search || '';

        var matchesFilter = !anyFilterActive || categories.indexOf(filter) !== -1;
        var matchesQuery = !anyQuery || haystack.indexOf(query) !== -1;
        var visible = matchesFilter && matchesQuery;

        if (visible) {
          card.removeAttribute('hidden');
          visibleCount++;
        } else {
          card.setAttribute('hidden', '');
        }
      }

      // Empty state when nothing matched.
      if (empty) {
        if (visibleCount === 0) {
          empty.removeAttribute('hidden');
        } else {
          empty.setAttribute('hidden', '');
        }
      }

      // Pagination only spans the current page, so hide it while filtering/searching.
      if (pagination) {
        if (anyFilterActive || anyQuery) {
          pagination.setAttribute('hidden', '');
        } else {
          pagination.removeAttribute('hidden');
        }
      }
    }

    function setActivePill(clicked) {
      for (var i = 0; i < pills.length; i++) {
        var pill = pills[i];
        var isActive = pill === clicked;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    }

    // Pills: set active, update filter, re-apply.
    pills.forEach(function (pill) {
      // Reflect initial active state for assistive tech.
      pill.setAttribute('aria-pressed', pill.classList.contains('is-active') ? 'true' : 'false');
      pill.addEventListener('click', function () {
        state.filter = pill.dataset.filter || 'All';
        setActivePill(pill);
        apply();
      });
    });

    // Search: debounced input.
    if (search) {
      var timer = null;
      search.addEventListener('input', function () {
        var raw = search.value;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          state.query = raw.trim().toLowerCase();
          apply();
        }, DEBOUNCE_MS);
      });
    }

    // Establish the initial view (respects any server-set active pill).
    var initialActive = root.querySelector('[data-sr-filter].is-active');
    if (initialActive && initialActive.dataset.filter) {
      state.filter = initialActive.dataset.filter;
    }
    apply();
  }

  function initAll(scope) {
    var containers = (scope || document).querySelectorAll('[data-sr-blog]');
    Array.prototype.forEach.call(containers, initBlog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-bind when a section is (re)loaded. Scope to the loaded
  // section so we only touch its container; binding stays idempotent.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
